export enum CustomTooltipComponentPosition {
  TOP,
  TOP_RIGHT,
  TOP_LEFT,
  RIGHT,
  BOTTOM,
  BOTTOM_RIGHT,
  BOTTOM_LEFT,
  LEFT
}